import { LucideCheck } from 'lucide-react';

import { Row } from '..';
import { cn } from '../../../lib/stylingUtils';

export type SelectableOptionProps = React.HTMLAttributes<HTMLInputElement> & {
  isFocused?: boolean;
  isDisabled?: boolean;
  isSelected?: boolean;
};

export const SelectableOption = ({
  className,
  children,
  isFocused,
  isDisabled,
  isSelected,
  onChange,
  onMouseDown,
  onMouseEnter,
  ...props
}: SelectableOptionProps) => (
  <Row
    yCenter
    gap1
    className={cn(
      '@SelectableOption',
      'w-full cursor-default rounded px-2 py-1 text-sm',
      isSelected ? 'text-neutral' : 'text-neutral/60',
      'hover:bg-primary hover:text-white',
      isFocused && 'bg-primary text-white',
      isDisabled && 'pointer-events-none opacity-50',
      className,
    )}
    onMouseDown={onMouseDown}
    onMouseEnter={onMouseEnter}
  >
    <input
      type="checkbox"
      className="hidden"
      checked={isSelected}
      onChange={onChange}
      {...props}
    />
    <label htmlFor="checkbox" className={cn('flex w-full items-center gap-2')}>
      <div
        className={cn(
          'h-[18px] w-[18px] rounded-md border border-neutral/20',
          isSelected && 'bg-primary',
          'relative',
        )}
      >
        <LucideCheck
          className={cn(
            'absolute inset-0 size-full text-white opacity-0 transition-opacity duration-200',
            isSelected && 'opacity-100',
          )}
        />
      </div>
      {children}
    </label>
  </Row>
);
